import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { LoggerService } from './core/logging/logger.service';

@Component({
  selector: 'mfr-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  template: `
    <mfr-header />
    <div class="mfr-main-content">
      <router-outlet />
    </div>
    <footer class="mfr-footer mfr-footer-fixed">© 2026 NBCUniversal — MFR Build 2.0</footer>
  `,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly logger = inject(LoggerService);

  ngOnInit(): void {
    this.logger.info('AppInitialized');
  }
}
